

export enum Operation {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
};
